/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CashBoxesStatisticsDto, CashboxesByStoreTypeDto, TurnoversBaseDto } from './statisticsClient.typings';
import { factoryT, fields } from 'factory-t';
import { StoreType } from '../stores/storesClientTypings';

export const cashBoxesStatisticsFactory = factoryT<CashBoxesStatisticsDto>({
    total: 100,
    states: {
        active: 951,
        blocked: 500,
        inactive: 220000,
        notBlocked: 30000000,
        offline: undefined, //700,
        online: undefined, //1100,
    },
    errors: {
        certificate: undefined, //50000,
        signature: undefined, //0,
        document: undefined, //40000,
        cashboxState: 122000,
        filesystem: 88800000,
        hardware: 0,
        others: 3,
    },
});

// TODO remove
export const cashboxesByActivityDtoFactory = factoryT<CashboxesByStoreTypeDto>({
    type: fields.sequence(Object.values(StoreType)),
    cashboxes: (ctx) => {
        return {
            online: ctx.index * 8 + 45,
            offline: ctx.index * 7 + 2,
            notReachable: 12,
            noDocuments: 7,
        };
    },
});

export const turnoversPartialDtoFactory = factoryT<TurnoversBaseDto>({
    cash: 1200,
    cashless: 456,
    credit: 23092,
    prepayment: 3223,
    bonus: 228,
    sales: (ctx) => {
        return {
            count: 23949,
            sum: 324 * ctx.index,
        };
    },
    moneybacks: {
        count: 123,
        sum: 3434,
    },
    rollbacks: {
        count: 323,
        sum: 2030,
    },
    corrections: {
        count: 342,
        sum: 3402340,
    },
});
